var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{staticClass:"px-4",attrs:{"title":"Login"}},[_c('login-form')],1),_c('b-tab',{staticClass:"px-4",attrs:{"title":"Signup"}},[_c('signup-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }